import React from 'react';
const defaultContextValue = {
    skin: 'dark',
    minimized: false,
    hidden: false,
    inert: false,
    level: 1,
    parent: 'sidebar',
    isFirstLevelWithPrefix: false,
    scrollAreaRef: { current: null },
    selectedPath: [],
    expandTrigger: 'select',
    legacy: false,
    isExpanded: () => false,
    setExpanded: () => { },
};
export const SidebarNextContext = React.createContext(defaultContextValue);
//# sourceMappingURL=SidebarNextContext.js.map